var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParking = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "parking_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#parking_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M7 26.829v3.233h11.375v4.875h3.25v-4.874H33v-3.234H7Zm4.875-4.892h16.25v3.25h3.25V13.31l-3.071-9.246H11.696l-3.071 9.246v11.879h3.25v-3.25Zm3.25-4.062A1.63 1.63 0 0 1 13.5 16.25a1.63 1.63 0 0 1 1.625-1.625 1.63 1.63 0 0 1 1.625 1.625 1.63 1.63 0 0 1-1.625 1.625Zm9.75 0a1.63 1.63 0 0 1-1.625-1.625 1.63 1.63 0 0 1 1.625-1.625A1.63 1.63 0 0 1 26.5 16.25a1.63 1.63 0 0 1-1.625 1.625ZM14.036 7.312h11.928l1.072 3.25H12.964l1.072-3.25Z"
}))));
export default SvgParking;